const SubSubHeaderDirective = function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: '<h6 class="light green-text"><ng-transclude></ng-transclude></h6>'
    }
};

export { SubSubHeaderDirective };